function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useState, useMemo, useRef, useEffect, useCallback } from 'react';
import { Page, TableList, PageEmptyState, DropdownMenu, PageErrorState, FilterPickerGroup, Searchbox, Button, PageContentHeader, Typography, ChipButton, useStateInRef, useGlobalContext, ConfirmationModal } from 'seagull';
import { WideArrowUpward, WideArrowDownward, TrashLine, MailSentLiner24 } from 'seagull/icons';
import { useStateFromUrl } from 'seagull/utils/useStateFromUrl';
import { useShallowStore, useStore, useStoreActions } from "../../contexts";
import { useInfiniteScroll } from "../../hooks/useInfiniteScroll";
import { useDebouncedLogSearchToBI } from "../../hooks/useDebouncedLogSearchToBI";
import { CreateProposalButton } from "../../components/CreateProposalButton";
import PageLoadingState from "../../components/PageLoadingState";
import { EmptyStateIllustration } from "./EmptyStateIllustration";
import { getUICompanyName, sortFunctions } from "./DraftsDashboard.utils";
import DraftsDashboardRow from "./DraftsDashboardRow";
import pluralize from 'pluralize';
import { Intent } from "../../infra/access-control";
import countBy from 'lodash/countBy';
import styles from "./DraftsDashboard.module.scss";
import isEmpty from 'lodash/isEmpty';
import mapValues from 'lodash/mapValues';
import { useBulkActionModal } from "../../hooks/useTerminateAgreement/useBulkActionModal";
import { handlePromise } from "../../infra/utils";
import { selectors } from "../../store/state-selectors";
import ExternalLinkButton from "../../components/ExternalLinkButton";
const title = 'Drafts';
export const headerIds = ['Company name', 'Modified by', 'Last modified'];
const headerItems = [{
  value: headerIds[0]
}, {
  value: headerIds[1]
}, {
  value: headerIds[2]
}];
const columnDefs = [{
  width: [180, 400],
  sortable: true
},
// Company name
{
  width: [120, 180],
  sortable: true
},
// Modified By
{
  width: 110,
  sortable: true
} // Last Modified
];
function ActualDraftsDashboard(props) {
  const {
    data,
    isRefreshing,
    refresh
  } = props;
  const [sort, setSort] = useState({
    colIndex: 2,
    sort: 'desc'
  });
  const {
    api,
    logBI
  } = useStoreActions();
  const globalContext = useGlobalContext();
  const isVendor = useStore(selectors.user.isVendor);
  const scrollElRef = useRef(null);
  const debouncedLogSearchToBI = useDebouncedLogSearchToBI(11352);
  const {
    urlState: {
      search
    },
    changeUrlState
  } = useStateFromUrl({
    search: {
      defaultValue: ''
    }
  });
  const [selected, setSelected] = useState({});
  const getSelected = useStateInRef(selected);
  const [bulkActionsOpen, setBulkActionsOpen] = useState(false);
  const numSelected = useMemo(() => {
    var _countBy$true;
    return (_countBy$true = countBy(selected).true) !== null && _countBy$true !== void 0 ? _countBy$true : 0;
  }, [selected]);
  const {
    doBulkAction
  } = useBulkActionModal();
  const drafts = useMemo(() => {
    const textSearchDraft = (search, draft) => {
      return "".concat(getUICompanyName(draft), " ").concat(draft.title).toLowerCase().includes(search);
    };
    const filtered = data ? data.filter(payout => {
      const normalizedSearch = search ? search.trim().toLowerCase() : search;
      const passesSearch = !normalizedSearch || textSearchDraft(normalizedSearch, payout);
      return passesSearch;
    }) : [];
    if (sort) {
      filtered.sort(sortFunctions[sort.colIndex](sort.sort === 'asc'));
    }
    return filtered;
  }, [data, sort, search]);
  const {
    paginatedData,
    onScroll
  } = useInfiniteScroll({
    data: drafts || [],
    scrollElRef
  });
  const hasDrafts = data && data.length > 0;
  const onToggleAllSelection = useCallback(selectAll => {
    setSelected(drafts.reduce((acc, _ref) => {
      let {
        id
      } = _ref;
      return Object.assign(acc, {
        [id]: selectAll
      });
    }, {}));
  }, [drafts]);
  useEffect(() => {
    // this unselects any proposal template that is not found in the newly fetched list of proposal templates
    if (!drafts || isEmpty(getSelected())) return;
    const ids = drafts.map(proposalTemplate => proposalTemplate.id);
    const newSelected = mapValues(getSelected(), (origValue, proposalTemplateId) => ids.includes(proposalTemplateId) ? origValue : false);
    setSelected(newSelected);
  }, [drafts]);
  function getSelectedDrafts() {
    return Object.entries(selected).filter(_ref2 => {
      let [, isSelected] = _ref2;
      return isSelected;
    }).map(_ref3 => {
      let [draftId, _] = _ref3;
      return draftId;
    });
  }
  async function bulkSend() {
    const selectedDrafts = getSelectedDrafts();
    await doBulkAction({
      bulkItemIds: selectedDrafts,
      confirmationTitle: 'Send proposals in bulk',
      confirmationPrimaryButtonLabel: 'Send proposals',
      confirmationContent: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, null, "By selecting \"Send Proposals,\" a proposal will be sent to each client of the", ' ', /*#__PURE__*/React.createElement(Typography, {
        "data-testid": "drafts-dashboard-remove-modal-template-name",
        as: "span",
        weight: "bold"
      }, selectedDrafts.length), ' ', "selected drafts?"), /*#__PURE__*/React.createElement(Typography, null, "Consider sending a personal message to clients still transitioning to Anchor.")),
      progressTitle: 'Send proposals in bulk',
      actionName: 'sent',
      itemName: 'proposal',
      errorExtra: 'due to missing or incorrect settings',
      onConfirmed: () => {},
      canProcessItem: () => true,
      processSingleItem: draftId => handlePromise(api.relationship.createFromDraft(draftId)).then(result => {
        if (!result.success) {
          var _draft$contactDetails, _result$error$respons, _result$error$respons2;
          const draft = drafts.find(draft => draft.id === draftId);
          const email = draft === null || draft === void 0 || (_draft$contactDetails = draft.contactDetails) === null || _draft$contactDetails === void 0 ? void 0 : _draft$contactDetails.email;
          if (((_result$error$respons = result.error.response) === null || _result$error$respons === void 0 ? void 0 : _result$error$respons.data.errors) != null) {
            const {
              code
            } = result.error.response.data.errors[0];
            return [undefined, "".concat(draft != null ? draft.title : 'Draft').concat(email != null ? " (".concat(email, ")") : '', " - missing ").concat(code === 'required-clientcontactid' ? 'contact' : code === 'services_or_service_bundles-services' ? 'services' : 'details'), true];
          } else if (((_result$error$respons2 = result.error.response) === null || _result$error$respons2 === void 0 ? void 0 : _result$error$respons2.data.error) === 'BuyerUserAssociatedWithVendor') {
            return [undefined, "".concat(draft != null ? draft.title : 'Draft').concat(email != null ? " (".concat(email, ")") : '', " - cannot send a proposal to a contact who is in your business"), true];
          } else {
            return [undefined, null, true];
          }
        } else {
          return [result.data, undefined, false];
        }
      }),
      onDone: failedDraftIds => {
        setSelected(failedDraftIds.reduce((acc, draftId) => _objectSpread(_objectSpread({}, acc), {}, {
          [draftId]: true
        }), {}));
      }
    });
    refresh();
  }
  async function bulkDiscard() {
    const selectedDrafts = getSelectedDrafts();
    await doBulkAction({
      bulkItemIds: selectedDrafts,
      confirmationTitle: 'Discard drafts',
      confirmationPrimaryButtonLabel: 'Discard',
      confirmationContent: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, null, "Are you sure you want to discard", ' ', /*#__PURE__*/React.createElement(Typography, {
        "data-testid": "drafts-dashboard-remove-modal-template-name",
        as: "span",
        weight: "bold"
      }, selectedDrafts.length), ' ', pluralize('draft', selectedDrafts.length), "?"), /*#__PURE__*/React.createElement(Typography, null, "This action cannot be undone.")),
      progressTitle: 'Discard drafts',
      actionName: 'discarded',
      itemName: 'draft',
      onConfirmed: () => {},
      canProcessItem: () => true,
      processSingleItem: draftId => handlePromise(api.draft.deleteById(draftId)).then(result => [result.data, null, !result.success]),
      onDone: failedDraftIds => {
        setSelected(failedDraftIds.reduce((acc, draftId) => _objectSpread(_objectSpread({}, acc), {}, {
          [draftId]: true
        }), {}));
      }
    });
    refresh();
  }
  const onSortChange = sort => {
    logBI(11350, {
      column: sort ? headerIds[sort.colIndex] : 'none'
    });
    setSort(sort);
  };
  const onClearSearch = () => {
    changeUrlState({
      search: ''
    });
    debouncedLogSearchToBI.onClear();
  };
  const openImportDraftsModal = () => {
    globalContext.showModal({
      content: _ref4 => {
        let {
          dismissModal
        } = _ref4;
        return /*#__PURE__*/React.createElement(ConfirmationModal, {
          textAlignCenter: false,
          primaryButtonLabel: "Close",
          onPrimaryButtonClick: dismissModal,
          onCloseButtonClick: dismissModal,
          title: "Import agreements",
          primaryButtonTestid: "close-import-agreements-modal",
          content: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, null, "Need to import agreements into Anchor that were signed elsewhere?"), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(ExternalLinkButton, {
            openInNewTab: true,
            href: "https://forms.gle/Q9sMHXFcp5Fs866FA"
          }, "Complete this form"), ' ', "and our team will reach out with the next steps."), /*#__PURE__*/React.createElement(Typography, {
            variant: "paragraph2",
            style: {
              marginTop: '16px'
            }
          }, "Please note: This service is currently available for requests of 30 agreements or more."))
        });
      }
    });
  };
  return /*#__PURE__*/React.createElement(TableList.Provider, {
    hasActionColumn: true,
    enableRowSelection: true,
    selectedRows: selected,
    columnDefs: columnDefs,
    sort: sort,
    onSortChange: onSortChange,
    onSelectionChange: setSelected,
    numRows: drafts.length,
    numSelectedRows: numSelected,
    onToggleAllSelection: onToggleAllSelection
  }, /*#__PURE__*/React.createElement(Page, {
    "data-testid": "drafts-dashboard",
    ref: scrollElRef,
    header: title,
    actions: hasDrafts && isVendor && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      skin: "primaryOutline",
      "data-testid": "import-drafts-btn",
      onClick: () => openImportDraftsModal()
    }, "Import"), /*#__PURE__*/React.createElement(CreateProposalButton, null)),
    loading: isRefreshing,
    onScroll: onScroll
  }, hasDrafts ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PageContentHeader, null, /*#__PURE__*/React.createElement(FilterPickerGroup, {
    style: {
      marginBlockEnd: '24px'
    }
  }, /*#__PURE__*/React.createElement(Searchbox, {
    registerHotkey: true,
    "data-testid": "drafts-dashboard-search",
    value: search,
    onChange: event => {
      const searchStr = event.target.value;
      changeUrlState({
        search: searchStr
      });
      debouncedLogSearchToBI.onChange(searchStr);
    },
    onClear: onClearSearch
  }), /*#__PURE__*/React.createElement(Typography, {
    className: styles.selectedItems,
    "data-testid": "drafts-dashboard-bulk-counter"
  }, numSelected > 0 ? "".concat(numSelected, " ").concat(pluralize('draft', numSelected), " selected") : ''), /*#__PURE__*/React.createElement(DropdownMenu, {
    onOpenChange: setBulkActionsOpen,
    target: /*#__PURE__*/React.createElement(ChipButton, {
      "data-testid": "drafts-dashboard-bulk-actions",
      suffixIcon: bulkActionsOpen ? /*#__PURE__*/React.createElement(WideArrowUpward, null) : /*#__PURE__*/React.createElement(WideArrowDownward, null),
      highlight: bulkActionsOpen,
      disabled: numSelected === 0
    }, "Bulk actions")
  }, /*#__PURE__*/React.createElement(DropdownMenu.Item, {
    iconStart: /*#__PURE__*/React.createElement(MailSentLiner24, null),
    "data-testid": "drafts-dashboard-bulk-send",
    onClick: bulkSend
  }, "Send proposals"), /*#__PURE__*/React.createElement(DropdownMenu.Item, {
    iconStart: /*#__PURE__*/React.createElement(TrashLine, null),
    skin: "error",
    intent: Intent.DiscardDraft,
    "data-testid": "drafts-dashboard-bulk-remove",
    onClick: bulkDiscard
  }, "Discard drafts"))), /*#__PURE__*/React.createElement(TableList.Header, {
    items: headerItems,
    "data-testid": "drafts-dashboard-table-header"
  })), drafts.length ? paginatedData.map((d, i) => /*#__PURE__*/React.createElement(DraftsDashboardRow, {
    key: d.id,
    draft: d,
    index: i,
    refresh: refresh
  })) : /*#__PURE__*/React.createElement(PageEmptyState, {
    illustration: /*#__PURE__*/React.createElement(EmptyStateIllustration, null),
    title: "No drafts match your request",
    message: "Try adjusting your search",
    actions: /*#__PURE__*/React.createElement(Button, {
      "data-testid": "drafts-dashboard-empty-search-clear-btn",
      onClick: onClearSearch
    }, "Clear search")
  })) : /*#__PURE__*/React.createElement(PageEmptyState, {
    "data-testid": "empty-state-page",
    illustration: /*#__PURE__*/React.createElement(EmptyStateIllustration, null),
    title: "No drafts yet",
    message: "Proposals awaiting completion will appear here.",
    actions: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      skin: "primaryOutline",
      "data-testid": "import-proposals-btn",
      onClick: () => openImportDraftsModal()
    }, "Import"), /*#__PURE__*/React.createElement(CreateProposalButton, {
      "data-testid": "drafts-empty-state-new-btn",
      text: "Create a new agreement",
      hidePrefix: true
    }))
  })));
}
export function DraftsDashboard() {
  const {
    drafts: {
      data: draftsData,
      error: draftsError,
      loading: draftsLoading
    },
    contacts: {
      data: contactsData,
      error: contactsError,
      loading: contactsLoading
    }
  } = useShallowStore(_ref5 => {
    let {
      drafts,
      contacts
    } = _ref5;
    return {
      drafts,
      contacts
    };
  });
  const {
    fetchContacts,
    fetchDrafts
  } = useStoreActions();
  const fetchData = () => {
    return Promise.all([fetchContacts(), fetchDrafts()]);
  };
  const draftsWithContactData = useMemo(() => {
    const contactMap = Object.fromEntries((contactsData !== null && contactsData !== void 0 ? contactsData : []).map(_ref6 => {
      let {
        id,
        firstName,
        lastName,
        email,
        companyName
      } = _ref6;
      return [id, {
        firstName,
        lastName,
        email,
        companyName
      }];
    }));
    return (draftsData !== null && draftsData !== void 0 ? draftsData : []).map(draft => {
      var _draft$clientContactI;
      return _objectSpread(_objectSpread({}, draft), {}, {
        contactDetails: contactMap[(_draft$clientContactI = draft.clientContactId) !== null && _draft$clientContactI !== void 0 ? _draft$clientContactI : '']
      });
    });
  }, [draftsData, contactsData]);
  useEffect(() => {
    document.title = title;
    fetchData();
  }, []);
  const hasData = draftsData && contactsData;
  const isLoading = draftsLoading || contactsLoading;
  const error = draftsError || contactsError;
  if (error) {
    return /*#__PURE__*/React.createElement(PageErrorState, {
      "data-testid": "error-state-page",
      title: title,
      onRefresh: fetchData
    });
  } else if (!hasData && isLoading) {
    return /*#__PURE__*/React.createElement(PageLoadingState, {
      header: title,
      loading: isLoading
    });
  } else {
    return /*#__PURE__*/React.createElement(ActualDraftsDashboard, {
      data: draftsWithContactData,
      isRefreshing: isLoading,
      refresh: fetchData
    });
  }
}